import styled from "styled-components";
import media from "../../static/style/media";

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1300px;
`;

export const CenterContainer = styled.div`
  display: grid;
  margin-top: 30px;
  grid-template-columns: 1fr 100fr;
  height: 800px;
  ${media.small`
    display: block;
  `};
`;
